import { useTranslation } from 'react-i18next';

import { LogoutOutline } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';
import { clearTokenFromStorage } from '@bonusly/who-am-i';

import { Route } from '../../config/router';
import { NavMenuItem } from '../Navigation/NavMenuItem';

const AuthButton = () => {
	const recognizeURL = useBuildRecognizeURL();
	const { t } = useTranslation('navigation');
	
	const handleLogoutClick = () => {
		// Clear widget JWT cookie before logout to prevent stale authentication
		clearTokenFromStorage();
	};
	
	return (
		<NavMenuItem 
			to={recognizeURL(Route.Logout)} 
			icon={<LogoutOutline />}
			onClick={handleLogoutClick}
		>
			{t('user_menu.log_out')}
		</NavMenuItem>
	);
};

export default AuthButton;
